import { FC, useCallback, useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Dispatch } from 'redux';

import { getUserInfo } from 'AuthPackage/MainModule/selectors/authSelectors';
import { ICheckNotification } from 'APIPackage/MainModule/interfaces/ICheckNotification';
import { IUserInfo } from 'APIPackage/AuthModule/interfaces/IUserInfo';

import { IRootState } from '../interfaces/IRootState';
import { CheckNotificationModal } from './CheckNotificationModal';
import { CheckNotificationTypesEnum } from '../enums/CheckNotificationTypesEnum';
import { getStorageItem, setStorageItem } from '../common/localStore';
import { StorageNamesEnum } from '../enums/StorageNamesEnum';
import { RootActions } from '../types/RootActions';
import { coreRemoveFirstNotificationInfo } from '../actions/coreActions';

interface ICheckNotificationProps {
  notificationInfo?: ICheckNotification[];
  userInfo: IUserInfo | undefined;
}

const CheckNotificationWithoutStore: FC<ICheckNotificationProps> = ({ children, notificationInfo, userInfo }) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const [isModalClose, setIsModalClose] = useState(false);

  const currentNotificationInfo: ICheckNotification | undefined = notificationInfo?.length
    ? notificationInfo[0]
    : undefined;
  const handleCloseModal = useCallback(() => {
    if (currentNotificationInfo?.showOnce && currentNotificationInfo.storageName) {
      setStorageItem(currentNotificationInfo.storageName, true);
    }
    dispatch(coreRemoveFirstNotificationInfo());
    notificationInfo?.length === 1 && setIsModalClose(true);
  }, [notificationInfo]);

  useEffect(() => {
    if (userInfo !== undefined && getStorageItem<boolean>(StorageNamesEnum.USER_FIRST_LOGIN) === undefined) {
      setIsModalClose(false);
    }
  }, [userInfo]);

  return (
    <>
      {children}
      <CheckNotificationModal
        visible={
          !!currentNotificationInfo &&
          !isModalClose &&
          currentNotificationInfo.userLKPlanNotificationType !== CheckNotificationTypesEnum.NONE
        }
        onConfirm={handleCloseModal}
        notificationType={currentNotificationInfo?.userLKPlanNotificationType}
      />
    </>
  );
};

const mapStateToProps = (state: IRootState) => ({
  userInfo: getUserInfo(state),
  notificationInfo: state.core.notificationInfo,
});

export const CheckNotification = connect(mapStateToProps)(CheckNotificationWithoutStore);
